// removed by extract-text-webpack-plugin
module.exports = {"new-testimonial-button":"style__new-testimonial-button___1ThkQ","testimonial-list":"style__testimonial-list___dnPvh","testimonial":"style__testimonial___2prNb","featured-testimonial-option":"style__featured-testimonial-option___2dG_7","testimonial-author":"style__testimonial-author___nu3yA","testimonial-organisation":"style__testimonial-organisation___1YWei","testimonial-text":"style__testimonial-text___3CJ6d","testimonial-link-panel":"style__testimonial-link-panel___JmF2Z","testimonial-link":"style__testimonial-link___1iV63"};


//////////////////
// WEBPACK FOOTER
// ./components/TestimonialList/style.scss
// module id = 1349
// module chunks = 0